import { Check, X } from "lucide-react";

const ComparisonTable = () => {
  const features = [
    { name: "All phonetic alphabets (IPA, NATO, regional)", free: true, pro: true, ltd: true },
    { name: "Real-time text conversion", free: true, pro: true, ltd: true },
    { name: "Copy to clipboard", free: true, pro: true, ltd: true },
    { name: "Dark & light themes", free: true, pro: true, ltd: true },
    { name: "100% local processing", free: true, pro: true, ltd: true },
    { name: "Batch text conversion", free: false, pro: true, ltd: true },
    { name: "Export to PDF/Word", free: false, pro: true, ltd: true },
    { name: "Custom pronunciation guides", free: false, pro: true, ltd: true },
    { name: "Multilingual support", free: false, pro: true, ltd: true },
    { name: "Priority support", free: false, pro: true, ltd: true },
    { name: "Early access to features", free: false, pro: true, ltd: true },
    { name: "Lifetime updates", free: false, pro: false, ltd: true },
    { name: "All future features", free: false, pro: false, ltd: true },
    { name: "Priority feature requests", free: false, pro: false, ltd: true },
    { name: "VIP Discord access", free: false, pro: false, ltd: true },
    { name: "No recurring fees", free: true, pro: false, ltd: true },
  ];

  const renderCell = (value: boolean) => {
    if (value === true) {
      return <Check className="w-4 h-4 text-green-500 mx-auto" />;
    }
    return <X className="w-4 h-4 text-muted-foreground/40 mx-auto" />;
  };

  return (
    <section className="py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h3 className="text-2xl font-semibold mb-2">Compare Plans</h3>
          <p className="text-muted-foreground">See exactly what you get with each plan</p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left py-4 px-4 font-medium text-sm">Feature</th>
                <th className="text-center py-4 px-4 font-medium text-sm w-24">Free</th>
                <th className="text-center py-4 px-4 font-medium text-sm w-24 bg-muted/50 rounded-t-lg">Pro</th>
                <th className="text-center py-4 px-4 font-medium text-sm w-24">LTD</th>
              </tr>
            </thead>
            <tbody>
              {features.map((feature, index) => (
                <tr 
                  key={feature.name} 
                  className={`border-b border-border/50 ${index % 2 === 0 ? 'bg-muted/20' : ''}`}
                >
                  <td className="py-3 px-4 text-sm">{feature.name}</td>
                  <td className="py-3 px-4 text-center">{renderCell(feature.free)}</td>
                  <td className="py-3 px-4 text-center bg-muted/30">{renderCell(feature.pro)}</td>
                  <td className="py-3 px-4 text-center">{renderCell(feature.ltd)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="border-t-2 border-border">
                <td className="py-4 px-4 font-medium text-sm">Price</td>
                <td className="py-4 px-4 text-center text-sm font-semibold">$0</td>
                <td className="py-4 px-4 text-center text-sm font-semibold bg-muted/30">$3.99/mo</td>
                <td className="py-4 px-4 text-center text-sm font-semibold text-primary">$14.99</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;